import { gql } from '@apollo/client';

export const UPDATE_BRANCH_DELIVERY = gql`
  mutation UpdateBranch($id: String!, $restaurantId: String!, $deliveryOrdersEnabled: Boolean!) {
    updateBranch(id: $id, restaurantId: $restaurantId, deliveryOrdersEnabled: $deliveryOrdersEnabled) {
      id
    }
  }
`;
